import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import type { DeletionRequestsData } from '@recruitee/account-types';
import { HttpApiService } from '@recruitee/http';

@Injectable({ providedIn: 'root' })
export class DeletionRequestsHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetchDeletionRequests(): Observable<DeletionRequestsData> {
    return this.httpApi.get('/deletion_requests', {}, { skipCompany: true });
  }
}
